import { styled } from '@mui/material';
import { OrderStatusColorKey } from 'themes/statusColors';

type Size = 'm' | 'l';

export type StatusIconProps = {
  size?: Size;
  color?: OrderStatusColorKey;
};

const sizeConfig: Record<Size, string> = {
  m: '16px',
  l: '18px',
};

export const StatusIcon = styled('div')<StatusIconProps>(({ theme, size = 'm', color }) => ({
  height: sizeConfig[size],
  width: sizeConfig[size],
  backgroundColor: color ? theme.palette.status.orderStatus[color] : theme.palette.divider,
  borderRadius: '100%',
}));
